var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-pageframe',{attrs:{"title":_vm.title}},[_c('v-container',{directives:[{name:"show",rawName:"v-show",value:(!_vm.is_auto_creating),expression:"!is_auto_creating"}],staticStyle:{"padding":"25px"},attrs:{"fluid":""}},[_c('m-auto-message-template-search-table',{ref:"autoMessageTable"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }